import reduce from 'ramda/src/reduce'
import path from 'ramda/src/path'
import replace from 'ramda/src/replace'
import prop from 'ramda/src/prop'
import compose from 'ramda/src/compose'
import split from 'ramda/src/split'
import set from 'ramda/src/set'
import lensPath from 'ramda/src/lensPath'
import tail from 'ramda/src/tail'
import last from 'ramda/src/last'
import join from 'ramda/src/join'

import { capitalize, camelCaseSpace } from 'root/src/shared/util/stringCase'

const dataPathKey = compose(
	tail,
	split('/'),
	prop('dataPath'),
)
const typePath = path(['params', 'type'])

const errorLimit = path(['params', 'limit'])

const getConstant = (schema, key) => compose(
	replace('1/', ''),
	path(['properties', key, 'const', '$data']),
)(schema)

const propTitle = errorPath => camelCaseSpace(last(errorPath))

export default (schema, errors) => reduce((result, error) => {
	const errorPath = dataPathKey(error)
	const propMsg = path(['properties', ...errorPath, 'errorMessage', error.keyword], schema)

	switch (error.keyword) {
	case 'errorMessage': {
		return set(
			lensPath(errorPath),
			error.message,
			result,
		)
	}
	case 'type': {
		return set(
			lensPath(errorPath),
			`${propTitle(errorPath)} should be a ${typePath(error)}`,
			result,
		)
	}
	case 'const': {
		return set(
			lensPath(errorPath),
			// Will prob eventually have to fix getConstant to follow paths
			`Must equal ${capitalize(getConstant(schema, last(errorPath)))}`,
			result,
		)
	}
	case 'minimum': {
		return set(
			lensPath(errorPath),
			`${propTitle(errorPath)} must be at least ${errorLimit(error)}`,
			result,
		)
	}
	case 'maximum': {
		return set(
			lensPath(errorPath),
			`${propTitle(errorPath)} must be at most ${errorLimit(error)}`,
			result,
		)
	}
	case 'isNotEmpty':
	case 'required': {
		return set(
			lensPath(errorPath),
			propMsg || `${propTitle(errorPath)} is required`,
			result,
		)
	}
	case 'minLength': {
		return set(
			lensPath(errorPath),
			`${propTitle(errorPath)} minimum ${errorLimit(error)} characters`,
			result,
		)
	}
	case 'minItems': {
		return set(
			lensPath(errorPath),
			`${propTitle(errorPath)} minimum ${errorLimit(error)} items`,
			result,
		)
	}
	case 'maxItems': {
		return set(
			lensPath(errorPath),
			`${propTitle(errorPath)} maximum ${errorLimit(error)} items`,
			result,
		)
	}
	case 'format': {
		return set(
			lensPath(errorPath),
			`Invalid ${error.params.format}`,
			result,
		)
	}
	case 'pattern': {
		const containsString = join(
			', ',
			split('|', replace(/[()]/g, '', error.params.pattern)),
		)
		return set(
			lensPath(errorPath),
			`Must contain ${containsString}`,
			result,
		)
	}
	case 'anyOf':
		return result
	default: {
		return set(
			lensPath(errorPath),
			JSON.stringify(error),
			result,
		)
	}
	}
}, {}, errors)
